// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___Pf1Ua";
var _2 = "styles-module__list___V_gpY";
export { _1 as "container", _2 as "list" }
